import { useQuery } from '@tanstack/react-query';
import { getPromoPage } from '../api/promoApi';

export function usePromoPageQuery({ alias, subdomain, promoSubdomain }) {
  const hasPromoIdentifier = Boolean(alias || promoSubdomain);

  return useQuery({
    queryKey: ['promo-page', alias, subdomain, promoSubdomain],
    queryFn: () => getPromoPage({ alias, subdomain, promoSubdomain }),
    enabled: Boolean(subdomain && hasPromoIdentifier),
  });
}
